var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoPlayerPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 84 85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M42 82.5c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40Z",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 30.361c0-1.909 0-2.863.399-3.396a2 2 0 0 1 1.459-.797c.664-.047 1.467.47 3.072 1.502l18.883 12.138c1.393.896 2.09 1.344 2.33 1.914a2 2 0 0 1 0 1.556c-.24.57-.937 1.018-2.33 1.914L36.93 57.33c-1.605 1.033-2.408 1.549-3.072 1.502a2 2 0 0 1-1.459-.797C32 57.502 32 56.548 32 54.64V30.36Z",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgVideoPlayerPlay;